import { Controller } from "@hotwired/stimulus"

/**
 * AI Tool Result Chip Controller — CONEK-3364 Wave 4.
 *
 * Toggles the expandable JSON details panel rendered by
 * AI::Companion::ToolResultChipComponent. Stateless — only manages the
 * `expanded` boolean value, the `hidden` class on the details pane, the
 * caret icon rotation, and the trigger button's aria-expanded attribute.
 *
 * Mirrors the React useState(expanded) collapsed-by-default behaviour
 * from ToolResultChip.tsx.
 */
export default class extends Controller {
  static targets = ["trigger", "details", "caret"]
  static values = { expanded: { type: Boolean, default: false } }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged(value) {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden", !value)
    }
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", value ? "true" : "false")
    }
    if (this.hasCaretTarget) {
      // Caret points right when collapsed, down when expanded — matches the
      // React component's ChevronRight ↔ ChevronDown swap.
      this.caretTarget.classList.toggle("rotate-90", value)
    }
  }
}
